import { useSyncExternalStore } from 'react';

const FEATURE_GATE_OVERRIDE_MANAGER_ENABLED_KEY = '__DEV_FEATURE_GATE_OVERRIDE_MANAGER_ENABLED__';

function getIsFeatureGateOverrideManagerEnabled(): boolean {
    return localStorage.getItem(FEATURE_GATE_OVERRIDE_MANAGER_ENABLED_KEY) === 'true';
}

function toggleFeatureGateOverrideManager(): boolean {
    const next = !getIsFeatureGateOverrideManagerEnabled();
    if (next) {
        localStorage.setItem(FEATURE_GATE_OVERRIDE_MANAGER_ENABLED_KEY, 'true');
    } else {
        localStorage.removeItem(FEATURE_GATE_OVERRIDE_MANAGER_ENABLED_KEY);
    }
    window.dispatchEvent(new StorageEvent('storage', { key: FEATURE_GATE_OVERRIDE_MANAGER_ENABLED_KEY }));
    return next;
}

const subscribeToFeatureGateOverrideManagerEnabled = (callback: () => void) => {
    const handler = (e: StorageEvent) => {
        if (e.key === FEATURE_GATE_OVERRIDE_MANAGER_ENABLED_KEY) {
            callback();
        }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
};

export default function useFeatureGateOverrideManagerEnabled(): boolean {
    return useSyncExternalStore(subscribeToFeatureGateOverrideManagerEnabled, getIsFeatureGateOverrideManagerEnabled);
}

declare global {
    interface Window {
        __toggleFeatureGateOverrideManager?: () => boolean;
    }
}

export function registerToggleFunction(): void {
    // eslint-disable-next-line no-underscore-dangle
    window.__toggleFeatureGateOverrideManager = () => {
        const enabled = toggleFeatureGateOverrideManager();
        // eslint-disable-next-line no-console
        console.log(`Feature gate override manager ${enabled ? 'enabled' : 'disabled'}`);
        return enabled;
    };
}
